<template>
  <p class="auth-help">
    <a href="#" @click.prevent="dialog = true">Need help?</a>

    <v-dialog v-model="dialog" max-width="400">
      <v-card class="auth-help-card">
        <v-card-title class="auth-help-card__title">
          Need help?
          <v-spacer />
          <v-btn icon small @click="dialog = false">
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="auth-help-card__body">
          <p class="auth-help-card__intro">
            Our customer service team is happy to assist you.
          </p>

          <a href="tel:+254730677000" class="auth-help-card__option">
            <v-icon color="#184679">mdi-phone</v-icon>
            <span>
              <span class="auth-help-card__option-label">Call us</span>
              <span class="auth-help-card__option-value">+254 730 677 000</span>
            </span>
          </a>

          <a href="mailto:customerservice@paciskenya.com" class="auth-help-card__option">
            <v-icon color="#184679">mdi-email-outline</v-icon>
            <span>
              <span class="auth-help-card__option-label">Email us</span>
              <span class="auth-help-card__option-value">customerservice@paciskenya.com</span>
            </span>
          </a>

          <a
            href="https://wa.me/254783620620"
            class="auth-help-card__option"
            target="_blank"
            rel="noopener noreferrer"
          >
            <v-icon color="#184679">mdi-whatsapp</v-icon>
            <span>
              <span class="auth-help-card__option-label">WhatsApp</span>
              <span class="auth-help-card__option-value">+254 783 620 620</span>
            </span>
          </a>
        </v-card-text>
      </v-card>
    </v-dialog>
  </p>
</template>

<script>
export default {
  name: 'NeedHelpDialog',
  data() {
    return {
      dialog: false,
    };
  },
};
</script>
